import React from 'react';

import List from '../../components/Associate/Category/List';
import Modal from '../../components/Associate/Category/Modal';
import Page from '../../components/DefaultManager';

export default function Category() {
  return (
    <Page
      path="/associate-category"
      title="Categorias de Parceiros"
      subTitle="Gerenciador de Categorias de Parceiros"
      selectedKey="9"
      List={List}
      ModalForm={Modal}
    />
  );
}
